module.exports = __webpack_public_path__ + "static/media/lq-banner-3.7ff02cce.jpg";